(function () {
  'use strict';

  var PAYLOAD_KEY = 'woodypanel_maak_compleet_data';
  var strings = window.MaakCompleetStrings || {};

  var root, sectionsEl, topbarProductEl, emptyEl;
  var cartAddUrl, cartUrl;
  var cartVariantIds = new Set();
  var cartVariantQty = new Map();
  var bundleVariantIds = new Set();
  var bundleConfig = null;
  var addedCount = 0;

  function qs(param) {
    var m = new RegExp('[?&]' + param + '=([^&]+)').exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function decodeEntities(str) {
    if (!str || str.indexOf('&') === -1) return str;
    var txt = document.createElement('textarea');
    txt.innerHTML = str;
    return txt.value;
  }

  function formatMoney(cents) {
    var n = Number(cents) / 100;
    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(n);
    } catch (e) {
      return '€' + n.toFixed(2);
    }
  }

  function readPayload() {
    try {
      var raw = sessionStorage.getItem(PAYLOAD_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function fetchCart() {
    return fetch(cartUrl + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartVariantIds = new Set((cart.items || []).map(function (i) { return i.variant_id; }));
        cartVariantQty = new Map((cart.items || []).map(function (i) { return [Number(i.variant_id), i.quantity]; }));
        updateTotalFromCart(cart);
        refreshCardQuantities();
        return cart;
      })
      .catch(function () { return { items: [] }; });
  }

  function refreshCardQuantities() {
    if (!root) return;
    var cards = root.querySelectorAll('[data-mc-card]');
    cards.forEach(function (card) {
      var addBtn = card.querySelector('[data-mc-card-add]');
      var variantId = Number((addBtn && addBtn.dataset.variantId) || card.dataset.variantId);
      var qty = cartVariantQty.get(variantId) || 0;
      updateCardQty(card, qty);
    });
  }

  function flashAdded(button) {
    if (!button) return;
    var icon = button.querySelector('[data-mc-card-add-icon]');
    var check = button.querySelector('[data-mc-card-add-check]');
    var defaultLabel = button.getAttribute('data-default-label');
    if (!defaultLabel) {
      defaultLabel = button.getAttribute('aria-label') || (strings.add || 'Toevoegen');
      button.setAttribute('data-default-label', defaultLabel);
    }
    if (icon) icon.hidden = true;
    if (check) check.hidden = false;
    button.classList.add('mc-card__add--flash');
    button.setAttribute('aria-label', strings.added || 'Toegevoegd');
    if (button._flashTimer) clearTimeout(button._flashTimer);
    button._flashTimer = setTimeout(function () {
      if (icon) icon.hidden = false;
      if (check) check.hidden = true;
      button.classList.remove('mc-card__add--flash');
      button.setAttribute('aria-label', defaultLabel);
    }, 1200);
  }

  function updateCardQty(card, qty) {
    var badge = card.querySelector('[data-mc-card-qty]');
    if (badge) {
      if (qty > 0) {
        badge.textContent = '×' + qty;
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.hidden = true;
      }
    }
    if (qty > 0) {
      card.classList.add('mc-card--added');
    } else {
      card.classList.remove('mc-card--added');
    }
  }

  function updateTotalFromCart(cart) {
    if (!root) return;
    var stickybar = root.querySelector('[data-mc-stickybar]');
    var stickyAmount = root.querySelector('[data-mc-stickybar-total]');
    if (!cart || typeof cart.total_price !== 'number') {
      if (stickyAmount) stickyAmount.textContent = '';
      if (stickybar) stickybar.hidden = true;
      return;
    }
    if (stickyAmount) stickyAmount.textContent = formatMoney(cart.total_price);
    if (stickybar) stickybar.hidden = false;
  }

  function addToCart(variantId, button) {
    button.setAttribute('aria-busy', 'true');
    return fetch(cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) return false;
        cartVariantIds.add(Number(variantId));
        addedCount += 1;
        updateSummaryCount();
        flashAdded(button);
        fetchCart();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
        return true;
      })
      .catch(function () { return false; })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  }

  function updateSummaryCount() {
    var countEl = root.querySelector('[data-mc-summary-count]');
    if (!countEl) return;
    if (addedCount <= 0) {
      countEl.hidden = true;
      countEl.textContent = '';
      return;
    }
    countEl.hidden = false;
    countEl.textContent = '+' + addedCount;
  }

  function updateCardPrice(card, variant) {
    var priceEl = card.querySelector('[data-mc-card-price]');
    var compareEl = card.querySelector('[data-mc-card-compare]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.comparePrice && Number(variant.comparePrice) > Number(variant.price)) {
        compareEl.textContent = formatMoney(variant.comparePrice);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
  }

  function wireVariantPicker(card, product, addBtn) {
    if (product.hasOnlyDefaultVariant || !product.variants || product.variants.length < 2) return;
    var wrap = card.querySelector('[data-mc-card-variants]');
    var select = card.querySelector('[data-mc-card-variants-select]');
    var label = card.querySelector('[data-mc-card-variants-label]');
    if (!wrap || !select) return;

    if (label) label.textContent = decodeEntities(strings.variantLabel || 'Variant');

    product.variants.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.textContent = decodeEntities(v.title + (!v.available ? ' — ' + (strings.soldOut || 'Uitverkocht') : ''));
      opt.disabled = !v.available;
      if (String(v.id) === String(product.variantId)) opt.selected = true;
      select.appendChild(opt);
    });

    wrap.hidden = false;

    select.addEventListener('change', function () {
      var picked = product.variants.find(function (v) { return String(v.id) === select.value; });
      if (!picked) return;
      addBtn.dataset.variantId = String(picked.id);
      updateCardPrice(card, picked);
      addBtn.disabled = !picked.available;
      updateCardQty(card, cartVariantQty.get(Number(picked.id)) || 0);
    });
  }

  function buildCard(product, template) {
    var node = template.content.cloneNode(true);
    var card = node.querySelector('[data-mc-card]');
    card.dataset.productId = product.id;
    card.dataset.variantId = product.variantId;

    node.querySelectorAll('[data-mc-card-link]').forEach(function (l) { l.href = product.url; });
    var titleEl = node.querySelector('[data-mc-card-title]');
    if (titleEl) titleEl.textContent = product.title;

    var typeEl = node.querySelector('[data-mc-card-type]');
    if (typeEl && product.type) {
      typeEl.textContent = product.type;
      typeEl.hidden = false;
    }

    var img = node.querySelector('[data-mc-card-image]');
    var placeholder = node.querySelector('[data-mc-card-placeholder]');
    if (img && product.image) {
      img.alt = product.imageAlt || product.title;
      img.src = product.image;
      img.onerror = function () {
        img.style.display = 'none';
        if (placeholder) placeholder.hidden = false;
      };
    } else {
      if (img) img.remove();
      if (placeholder) placeholder.hidden = false;
    }

    updateCardPrice(card, product);

    var addBtn = node.querySelector('[data-mc-card-add]');
    addBtn.dataset.variantId = String(product.variantId);
    if (!product.available) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-label', strings.soldOut || 'Uitverkocht');
      card.classList.add('mc-card--unavailable');
    } else {
      addBtn.addEventListener('click', function () {
        var variantId = addBtn.dataset.variantId || product.variantId;
        addToCart(variantId, addBtn);
      });
    }

    wireVariantPicker(card, product, addBtn);

    return node;
  }

  function renderSection(section, stepNumber, template) {
    if (!section || !section.products || !section.products.length) return null;

    var wrapper = document.createElement('section');
    wrapper.className = 'mc-section';

    var header = document.createElement('div');
    header.className = 'mc-section__header';
    header.innerHTML =
      '<span class="mc-section__step" aria-hidden="true">' + stepNumber + '</span>' +
      '<div class="mc-section__heading">' +
        '<h2 class="mc-section__title"></h2>' +
        '<p class="mc-section__subtitle" hidden></p>' +
      '</div>';
    header.querySelector('.mc-section__title').textContent = decodeEntities(section.label || '');
    var subtitleEl = header.querySelector('.mc-section__subtitle');
    if (section.subtitle) {
      subtitleEl.textContent = decodeEntities(section.subtitle);
      subtitleEl.hidden = false;
    }
    wrapper.appendChild(header);

    var grid = document.createElement('div');
    grid.className = 'mc-section__grid';
    section.products.forEach(function (p) {
      var card = buildCard(p, template);
      grid.appendChild(card);
    });
    wrapper.appendChild(grid);

    return wrapper;
  }

  function hydrateTopbar(product) {
    var link = root.querySelector('[data-mc-summary-link]');
    var img = root.querySelector('[data-mc-summary-image]');
    var title = root.querySelector('[data-mc-summary-title]');
    var price = root.querySelector('[data-mc-summary-price]');

    if (link) {
      link.href = product.url || '#';
      link.hidden = false;
    }
    if (img && product.image) {
      img.src = product.image;
      img.alt = product.title;
    } else if (img) {
      img.remove();
    }
    if (title) title.textContent = product.title;
    if (price && product.price != null) price.textContent = formatMoney(product.price);
  }

  function wireBackLink() {
    var back = root.querySelector('[data-mc-back]');
    if (!back) return;
    var payload = readPayload();
    if (payload && payload.product && payload.product.url) {
      back.href = payload.product.url;
    }
  }

  function showEmpty() {
    emptyEl.hidden = false;
  }

  function interpolate(str, params) {
    if (!str) return '';
    var out = str;
    Object.keys(params || {}).forEach(function (key) {
      out = out.replace('__' + key.toUpperCase() + '__', params[key]);
    });
    return out;
  }

  function renderBundle(bundle, mainProduct) {
    if (!bundle || !bundle.products || !bundle.products.length) return null;

    var wrapper = document.createElement('section');
    wrapper.className = 'mc-bundle';
    wrapper.setAttribute('data-mc-bundle', '');

    var allItems = [];
    if (mainProduct) allItems.push(mainProduct);
    bundle.products.forEach(function (p) { allItems.push(p); });

    var visual = document.createElement('div');
    visual.className = 'mc-bundle__visual';
    var heroSrc = (mainProduct && (mainProduct.imageLarge || mainProduct.image)) || '';
    var heroAlt = (mainProduct && mainProduct.title) || '';
    visual.innerHTML =
      (heroSrc
        ? '<img class="mc-bundle__visual-image" src="' + heroSrc + '" alt="' + heroAlt + '" loading="lazy" />'
        : '<span class="mc-bundle__visual-placeholder" aria-hidden="true"></span>') +
      '<span class="mc-bundle__visual-overlay" aria-hidden="true"></span>' +
      '<span class="mc-bundle__set-badge">' + decodeEntities(strings.bundleSetLabel || 'Complete Look') + '</span>';
    wrapper.appendChild(visual);

    var commerce = document.createElement('div');
    commerce.className = 'mc-bundle__commerce';

    var header = document.createElement('div');
    header.className = 'mc-bundle__header';
    header.innerHTML =
      '<span class="mc-bundle__badge"></span>' +
      '<div class="mc-bundle__heading">' +
        '<h2 class="mc-bundle__title"></h2>' +
        '<p class="mc-bundle__subtitle"></p>' +
      '</div>';
    header.querySelector('.mc-bundle__badge').textContent =
      interpolate(strings.bundleBadge || '-__PERCENT__%', { percent: bundle.discountPercent });
    header.querySelector('.mc-bundle__title').textContent =
      decodeEntities(strings.bundleTitle || 'Koop samen & bespaar');
    header.querySelector('.mc-bundle__subtitle').textContent = decodeEntities(
      interpolate(strings.bundleSubtitle || '', { percent: bundle.discountPercent })
    );
    commerce.appendChild(header);

    var list = document.createElement('ul');
    list.className = 'mc-bundle__lines';
    allItems.forEach(function (p) {
      var li = document.createElement('li');
      li.className = 'mc-bundle__line';
      li.innerHTML =
        '<span class="mc-bundle__line-name"></span>' +
        '<span class="mc-bundle__line-price">' + formatMoney(p.price) + '</span>';
      li.querySelector('.mc-bundle__line-name').textContent = decodeEntities(p.title || '');
      list.appendChild(li);
    });
    commerce.appendChild(list);

    var totalCents = 0;
    allItems.forEach(function (p) { totalCents += Number(p.price) || 0; });
    var savingsCents = Math.round(totalCents * (bundle.discountPercent || 0) / 100);
    var nowCents = totalCents - savingsCents;

    var totalRow = document.createElement('div');
    totalRow.className = 'mc-bundle__totals';
    totalRow.innerHTML =
      '<span class="mc-bundle__total-label">Bundelprijs</span>' +
      '<span class="mc-bundle__total-now">' + formatMoney(nowCents) + '</span>';
    commerce.appendChild(totalRow);

    if (savingsCents > 0) {
      var savePill = document.createElement('div');
      savePill.className = 'mc-bundle__save';
      savePill.innerHTML =
        '<svg class="mc-bundle__save-check" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="3">' +
          '<path d="m5 12 5 5 9-10" stroke-linecap="round" stroke-linejoin="round" />' +
        '</svg>' +
        '<span>Je bespaart ' + formatMoney(savingsCents) + '</span>';
      commerce.appendChild(savePill);
    }

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'mc-bundle__cta';
    cta.setAttribute('data-mc-bundle-add', '');
    cta.innerHTML =
      '<span class="mc-bundle__cta-icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5">' +
          '<path d="M3 4h2l2 12h12l2-8H6" stroke-linecap="round" stroke-linejoin="round" />' +
          '<circle cx="9" cy="20" r="1.4" fill="currentColor" stroke="none" />' +
          '<circle cx="18" cy="20" r="1.4" fill="currentColor" stroke="none" />' +
        '</svg>' +
      '</span>' +
      '<span>' + decodeEntities(strings.bundleCta || 'Voeg de bundel toe') + '</span>';
    cta.addEventListener('click', function () {
      addBundleToCart(bundle, cta);
    });
    commerce.appendChild(cta);

    wrapper.appendChild(commerce);
    return wrapper;
  }

  function addBundleToCart(bundle, button) {
    if (!bundle || !bundle.products || !bundle.products.length) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var items = bundle.products.map(function (p) {
      return { id: p.variantId, quantity: 1 };
    });
    return fetch(cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) return false;
        bundle.products.forEach(function (p) { cartVariantIds.add(Number(p.variantId)); });
        addedCount += items.length;
        updateSummaryCount();
        flashBundleAdded(button);
        fetchCart();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));
        return true;
      })
      .catch(function () { return false; })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  }

  function flashBundleAdded(button) {
    if (!button) return;
    var bundleEl = root.querySelector('[data-mc-bundle]');
    if (bundleEl) {
      bundleEl.classList.add('mc-bundle--added');
      setTimeout(function () { bundleEl.classList.remove('mc-bundle--added'); }, 1600);
    }
    if (!button.dataset.defaultHtml) button.dataset.defaultHtml = button.innerHTML;
    button.innerHTML =
      '<span class="mc-bundle__cta-icon" aria-hidden="true">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="3">' +
          '<path d="m5 12 5 5 9-10" stroke-linecap="round" stroke-linejoin="round" />' +
        '</svg>' +
      '</span>' +
      '<span>Bundel toegevoegd!</span>';
    button.classList.add('mc-bundle__cta--success');
    if (button._flashTimer) clearTimeout(button._flashTimer);
    button._flashTimer = setTimeout(function () {
      button.innerHTML = button.dataset.defaultHtml;
      button.classList.remove('mc-bundle__cta--success');
      button.disabled = false;
    }, 1600);
  }

  function hasBundleInCart() {
    if (!bundleVariantIds.size) return false;
    var found = false;
    bundleVariantIds.forEach(function (id) {
      if (cartVariantIds.has(id)) found = true;
    });
    return found;
  }

  function wireCartCtaDiscountRedirect() {
    if (!bundleConfig || !bundleConfig.discountCode) return;
    var ctas = root.querySelectorAll('.mc-topbar__cta, .mc-stickybar__cta');
    ctas.forEach(function (cta) {
      cta.addEventListener('click', function (e) {
        var hasBundle = hasBundleInCart();
        console.log('[MC] cart CTA clicked. hasBundle=', hasBundle, 'bundleVariantIds=', Array.from(bundleVariantIds), 'cartVariantIds=', Array.from(cartVariantIds));
        if (!hasBundle) return;
        e.preventDefault();
        var target = '/discount/' + bundleConfig.discountCode + '%2525?redirect=' + cartUrl;
        console.log('[MC] redirecting to:', target);
        window.location.href = target;
      });
    });
  }

  function start() {
    root = document.querySelector('[data-mc-root]');
    if (!root) return;
    sectionsEl = root.querySelector('[data-mc-sections]');
    emptyEl = root.querySelector('[data-mc-empty]');
    cartAddUrl = root.dataset.routesCartAdd || '/cart/add.js';
    cartUrl = root.dataset.routesCart || '/cart';

    wireBackLink();

    var requestedId = qs('id');
    var payload = readPayload();

    if (!payload || !payload.product || (requestedId && String(payload.product.id) !== String(requestedId))) {
      showEmpty();
      return;
    }

    var template = root.querySelector('[data-mc-card-template]');

    if (payload.bundle && payload.bundle.products && payload.bundle.products.length) {
      bundleConfig = payload.bundle;
      bundleVariantIds = new Set(payload.bundle.products.map(function (p) { return Number(p.variantId); }));
    }

    fetchCart().then(function () {
      hydrateTopbar(payload.product);

      var bundleNode = renderBundle(bundleConfig, payload.product);
      if (bundleNode) sectionsEl.appendChild(bundleNode);

      var sections = Array.isArray(payload.sections) ? payload.sections : [];
      var step = 1;
      sections.forEach(function (section) {
        if (!section) return;
        var node = renderSection(section, step, template);
        if (node) {
          sectionsEl.appendChild(node);
          step += 1;
        }
      });

      refreshCardQuantities();
      wireCartCtaDiscountRedirect();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
